<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">{{ employee ? employee.name : 'Bono' }}</h4>
                <button ref="closeBonoModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    
                    <div class="row">
                        <div class="col-sm-12" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Monto de Bono</label>
                                <input class="form-control" type="text" v-model="form.bono" v-bind:class="formSubmitted ? errors.bono ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.bono = form.bono.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.bono">{{ errors.bono }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="updateEmployeeBonoValidation">Modificar Bono</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css' 

import validations from "@/mixins/validations/employeeValidations";

export default {
    name: 'employee_bono_modal',
    mixins: [validations],
    props: {
        employee: Object,
    },
    components: {
        Datepicker
    },
    data(){
        return{
            showModal: true,
            employee: null
        }
    },
    beforeMount: async function() {
        this.clearForm();
    },
    methods: {
        loadEmployee(employee){
            this.employee = employee;

            this.form.id = employee.id;
            this.form.bono = employee.bono_amount;
        },
        async storeEmployeeBono(form) {
            let response = await ws.updateBono(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("refresh", response.data );
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeBonoModal.click();
        }
    }
}
</script>